import React from 'react';
import {Bar, BarChart, ResponsiveContainer, Tooltip, XAxis, YAxis} from 'recharts';
import {
    ChartCard,
    ChartHeader,
    ChartSubtitle,
    ChartTitle,
    MetricCard,
    MetricLabel,
    MetricsGrid,
    MetricSub,
    MetricValue,
} from './styles';
import {useDashboardContext} from "../../../Dashboard";
import {Alert, CircularProgress, Stack} from "@mui/material";
import {NoOneGroup} from "../VkConnectCard/VkConnectCard";
import {Tabs} from "../../Tabs";

const StatsItem = ({stats}) => {
    const {STATS_DATA} = useDashboardContext();

    const statsMetricViewsGrowth = STATS_DATA.metricViewsGrowth.replace("{{viewsGrowthPercent}}", (v => (v > 0 ? "+" : "") + v)(stats?.viewsGrowthPercent));

    if(!stats)return ;


    return (
        <>
            <div style={{width: '100%', height: 160}}>
                <ResponsiveContainer width="100%" height="100%">
                    <BarChart data={stats.data} margin={{top: 10, right: 10, left: -20, bottom: 0}}>
                        <XAxis dataKey="day" tick={{fontSize: 11}} stroke="#888"/>
                        <YAxis tick={{fontSize: 11}} stroke="#888"/>
                        <Tooltip contentStyle={{fontSize: 12, borderRadius: 8}}/>
                        <Bar dataKey="views" fill="#d81b60" radius={[4, 4, 0, 0]} name={STATS_DATA.chartLabelViews}/>
                    </BarChart>
                </ResponsiveContainer>
            </div>
            <MetricsGrid>
                <MetricCard>
                    <MetricLabel>{STATS_DATA.metricViewsTitle}</MetricLabel>
                    <MetricValue>{stats.viewsValue}</MetricValue>
                    <MetricSub>{statsMetricViewsGrowth}</MetricSub>
                </MetricCard>
                <MetricCard>
                    <MetricLabel>{STATS_DATA.metricPostsTitle}</MetricLabel>
                    <MetricValue>{stats.postCount}</MetricValue>
                    <MetricSub>{STATS_DATA.metricPostsGrowth}</MetricSub>
                </MetricCard>
            </MetricsGrid>
        </>
    )
}

const Stats = ({onConnect}) => {
    const {groups, groupsError} = useDashboardContext();

    if (groupsError) return <Alert color={"error"}>Ошибка: не удалось загрузить статистику</Alert>
    if (!groups) return <CircularProgress/>
    if (!groups.filter(group=>group.joined).length) return <NoOneGroup onConnect={onConnect}/>

    const items = groups.filter(group=>group.joined).map(({name, stats}) => ({name, body: <StatsItem stats={stats}/>}));

    return (
        <Tabs key={new Date()} items={items}/>
    )
}

export default function StatsChart({onConnect}) {
    const {STATS_DATA, stats} = useDashboardContext();

    const statsSubtitle = stats?.[0]?.stats?.period && STATS_DATA.subtitle.replace("{{period}}", stats[0].stats.period);

    return (
        <ChartCard>
            <ChartHeader>
                <Stack sx={{gap: 0.5}}>
                    <ChartTitle>{STATS_DATA.title}</ChartTitle>
                    <ChartSubtitle>{statsSubtitle}</ChartSubtitle>
                </Stack>
            </ChartHeader>
            <Stats onConnect={onConnect}/>
        </ChartCard>
    );
}
